// /home/Hakyury/sites/oauth.eight-percent.com/frontend/src/hooks/useInitAuth.js

import { useEffect } from 'react';
import { initAuthTimers, extractTokensFromURL, checkSession } from '../utils/authFetch';

export function useInitAuth() {
  useEffect(() => {
    // 1. Извлекаем токены из URL (если есть)
    const tokensExtracted = extractTokensFromURL();
    
    // 2. Инициализируем таймеры обновления токенов
    initAuthTimers();
    
    // 3. Если токены были из URL, проверяем сессию
    if (tokensExtracted) {
      checkSession().catch(() => {
        // Обработка ошибки сессии
      });
    }
    
    // 4. Синхронизация между вкладками
    const handleStorageChange = (e) => {
      // Перезагружаем только при изменении токенов
      if (e.key === 'eight_percent_access_token' || e.key === 'eight_percent_refresh_token') {
        window.location.reload();
      }
    };
    
    window.addEventListener('storage', handleStorageChange);
    
    return () => {
      window.removeEventListener('storage', handleStorageChange);
    };
  }, []);
}